import InvitationVue from '@/views/sa/invitation/invitation.vue';

const basePath = '/sa/invitation';
const role = 'sa'; // 角色身份

export const SA_INVITATION_INDEX = 'sa-invitation-index';
export const SA_INVITATION_PREVIEW = 'sa-invitation-preview';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: InvitationVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SA_INVITATION_INDEX,
      props: true,
      component: () => import(
        /* webpackChunkName: "reservation" */
        `@/views/${role}/invitation/index.vue`
        ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/preview`,
      name: SA_INVITATION_PREVIEW,
      props: true,
      component: () => import(
        /* webpackChunkName: "reservation" */
        `@/views/${role}/invitation/preview.vue`
        ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
